const doWindow = window;
export class EventContactUs {
    constructor() {
        this.init();
    }
    init() {
        const form = document.getElementById("subaru-event-contact-us");
        if (form) {
            form.addEventListener("submit", (e) => {
                e.preventDefault();
            });
        }
        doWindow.DealeronLead.addSubmissionMethod("subaruEventContactUsSubmit", {});
        doWindow.DealeronLead.initialize("#subaru-event-contact-us", "subaruEventContactUsSubmit");
        const firstNameField = document.getElementById("eventContactUsFirstName");
        if (firstNameField) {
            firstNameField.addEventListener("change", doWindow.DealeronLead.begin);
        }
    }
}
doWindow.DoUtility.SelfInstantiateOnLoad(EventContactUs);
